// add fixed class to header when scroll down
window.addEventListener('scroll', function () {
    var sc = window.pageYOffset || document.documentElement.scrollTop;
    if (sc > 100) {
      document.querySelector('#masthead').classList.add('fixed');
    } else {
      document.querySelector('#masthead').classList.remove('fixed');
    }
});